import styled from 'styled-components';

const ExposeHeader = styled.div`
  background-color: #fff;
  height: 80px;
  margin-bottom: 20px;
  padding: 20px;
  border-bottom: 1px solid #aaa;
`;

export default ExposeHeader;
